const BASE_URL = process.env.REACT_APP_API_ENDPOINT
const BASE_PATH = '/api/v1/generic/'

const generateSignedURL = `${BASE_URL}${BASE_PATH}generate-signed-url/`

export default {
  generateSignedURL
}
